import React, { useEffect } from 'react';
import { CredentialSearchbar } from '../../CredentialSearchbar';
import { CredentialLayoutBox } from '../../CredentialLayoutBox';
import { NoItemView } from '../../NoItemView';
import { inIframe } from '../../../utils';
import { useProfileCredentials } from '../../../hooks';
import { ICredential } from '../../../model';

const CredentialsContainer = ({username, t, appData, setAppData}) => {
    const {
        userCredentials,
        userCredentialsLoaded,
        discoverCredentials,
        discoverCredentialsLoaded,
    } = useProfileCredentials(username);

    useEffect(() => {
        setAppData({
            ...appData,
            userCredentials: userCredentials as ICredential[],
            userCredentialsLoaded: userCredentialsLoaded as boolean,
        });
    }, [userCredentialsLoaded]);
    
  
   
    return (
      <>
            <div className="div-block-502">
                <div className="text-block-272 pr_t">{t('Credentials')}</div>
                <div>
                    <div className="w-layout-hflex flex-block-22"></div>
                    <div className="profile-panels">
                        <div className="ov_panel active" data-name={'credentials'}>
                            <div>
                                <div className="form-block-15 w-form">
                                    <CredentialSearchbar></CredentialSearchbar>
                                </div>

                                <CredentialLayoutBox
                                    userCredentials={userCredentials as ICredential[]}
                                    userCredentialsLoaded={userCredentialsLoaded as boolean}
                                    discoverCredentials={discoverCredentials as ICredential[]}
                                    discoverCredentialsLoaded={
                                        discoverCredentialsLoaded as boolean
                                    }
                                    userName={username}
                                ></CredentialLayoutBox>

                                {userCredentials?.length === 0 &&
                                    userCredentialsLoaded &&
                                    inIframe() && (
                                        <NoItemView
                                            displayMessage={`${username} hasn't earned any credentials yet.`}
                                            imageUrl={'/images/tools.png'}
                                            displayPadding={true}
                                        />
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      </>
    )
}

export default CredentialsContainer;